import React from 'react';
import {
  BoldBodyText,
  Header4Text,
  Notification,
  SmallBodyText,
} from 'ui-toolkit';
import styled from 'styled-components';
import { ISODateTimeString } from 'types/shared/ISODateTimeString';
import { DateTime } from 'luxon';
import { eUserType, prettyUserType } from '../../../../ui-toolkit/orders/interfaces/eUserType';
import { eCancellationRequestStatus } from '../../../../ui-toolkit/orders/interfaces/eCancellationRequestStatus';

interface ICancellationRequestMessageProps {
  onClick: () => void;
  requestCreatedBy: eUserType;
  status: eCancellationRequestStatus;
  message?: string;
  updatedAt?: ISODateTimeString;
  isCancelled?: boolean;
  resolver?: string;
}

const OrderCanceledSummary = styled.ul`
  margin: 0;
  padding: 0;
`;

export const CancellationRequestMessage: React.FC<ICancellationRequestMessageProps> = ({
  onClick,
  requestCreatedBy,
  status,
  message,
  updatedAt,
  isCancelled,
  resolver,
}) => {
  const getUserType = (): string => {
    switch (requestCreatedBy) {
      case eUserType.ClientCompany:
        return prettyUserType.ClientUser;
      case eUserType.LenderCompany:
        return prettyUserType.LenderUser;
      default:
        return prettyUserType[requestCreatedBy];
    }
  };
  return (
    <>
      {status === eCancellationRequestStatus.Declined && (
        <Notification type="warning" mode={'inverted'}>
          <div>
            <DecoratedText>Cancellation Rejected.</DecoratedText>{' '}
            <span> File still active, please reach out to {getUserType()} with further context.</span>
          </div>
        </Notification>
      )}
      {status === eCancellationRequestStatus.Pending && (
        <Notification type="warning" mode={'inverted'}>
          <div>
            <ActiveText onClick={onClick}>Cancellation Pending. </ActiveText>{' '}
            <span>
              Requested by {prettyUserType[requestCreatedBy]}. Please confirm or reject cancellation of this order.
            </span>
          </div>
        </Notification>
      )}
      {status === eCancellationRequestStatus.Completed && isCancelled && (
        <Notification type="error" mode={'inverted'}>
          <>
            <Header4Text>Order Cancelled</Header4Text>
            <OrderCanceledSummary>
              {message && (
                <li>
                  <SmallBodyText>Reason: {message}</SmallBodyText>
                </li>
              )}
              {updatedAt && (
                <li>
                  <SmallBodyText>
                    {DateTime.fromISO(updatedAt, { setZone: true }).toFormat(
                      `'${resolver ? `${resolver} cancelled` : 'Order cancelled'} on 'MM/dd/yyyy 'at' hh:mma ZZZZ`
                    )}
                  </SmallBodyText>
                </li>
              )}
            </OrderCanceledSummary>
          </>
        </Notification>
      )}
    </>
  );
};

const DecoratedText = styled(BoldBodyText)`
  text-decoration: underline;
  display: inline-block;
`;

const ActiveText = styled(DecoratedText)`
  cursor: pointer;
`;
